import React from 'react';
import { Helmet } from 'react-helmet';
import { Typography } from 'antd';

import { PAGE_TITLE } from '../../constants/app';
import useBillingCycle from '../../hooks/useBillingCycle';

import BillingCycleSwitch from '../../components/billingCycleSwitch';
import PageHeader from '../../components/pageHeader';
import Plans from '../../components/plans';

import ProfessionalService from './subcomponents/professionalService';

import { Section } from './style';

const Pricing = () => {
  const [billingCycle, handleBillingChange] = useBillingCycle();

  return (
    <>
      <Helmet>
        <title>{`Pricing - ${PAGE_TITLE}`}</title>
      </Helmet>
      <Section>
        <PageHeader title="Pricing">
          <Typography.Paragraph>
            Get access to the most comprehensive on-chain data suite, providing live charts, a comprehensive API, and
            insights from industry experts.
          </Typography.Paragraph>
        </PageHeader>
      </Section>

      <Section>
        <BillingCycleSwitch onChange={handleBillingChange} />
        <Plans billingCycle={billingCycle} />
      </Section>

      <Section>
        <ProfessionalService />
      </Section>
    </>
  );
};

export default Pricing;
